import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t('id'), key: 'id' },
      { label: t('customerName'), key: 'customerName' },
      { label: t('assignedAssociate'), key: 'associate' },
      { label: t('dueDate'), key: 'dueDate' },
      { label: t('orderStatus'), key: 'status' },
      { label: t('itemCount'), key: 'itemCount' },
      { label: t('orderType'), key: 'orderType' },
    ],
    [t],
  );
};
